<template>
  <div class="form-con search whaty-search-input-number" v-clickoutside="handleClose">
    <div class="input-wrap" data-role="textSearch"
         @mouseenter="hovering = true"
         @mouseleave="hovering = false"
    >
      <div ref="myInput">
        <input type="number" class="form-control"
               v-model.number="currentValue"
               :placeholder="placeholder"
               :style="inputStyle"
               @input="handleInput"
               @change="handleChange"
               @click="onInputClick"
               @blur="onInputBlur('input')"
               @compositionend="onCompositionend">
        <div type="text" style="line-height: 32px" class="form-control" @click.capture="onClickNumber('end')" :style="numTextStyle">
          <span  type="text" @click="onClickNumber('start')">{{ scopeStart || scopeStart === 0 ? scopeStart : '—' }}</span>
          <span  type="text" class="info">&nbsp; 至&nbsp; </span>
          <span  type="text">{{ scopeEnd || scopeEnd === 0 ? scopeEnd : '—' }}</span>
        </div>
      </div>
      <div v-if="nannSearch" @click="showSearchHistoryPanel = true"
           class="nann-tip-wrapper">
        <el-tag v-if="nannSearch === '!null'" size="mini">已填写</el-tag>
        <el-tag v-if="nannSearch === 'null'" size="mini">未填写</el-tag>
      </div>
      <span ref="myInputSuffix" class="el-input__suffix">
        <span class="el-input__suffix-inner">
          <i v-if="showClear" @click="clear" class="el-input__icon el-icon-circle-close el-input__clear"></i>
        </span>
      </span>
    </div>
    <!----------- dropdown search: text ---------->
    <whaty-dropdown ref="myPopper" v-show="showSearchHistoryPanel" v-model="showSearchHistoryPanel" :reference-name="'myInput'" class="wsin-search-history">
      <div
        :style="searchHistoryStyle"
        class="history-panel drop drop-search" data-textSearch="drop-history">
        <div class="drop-top">
          <div class="drop-form-row">
            <div class="form-con">
              <div class="input-wrap">
                <input id="numStart" v-model.number="scopeStart" @input="handleScopeInput" @blur="onInputBlur('start')" type="number" class="form-control">
              </div>
            </div>
            <span class="drop-txt" style="margin: 0 4px">至</span>
            <div class="form-con">
              <div class="input-wrap">
                <el-tooltip ref="scopeTip" :manual="true" :value="scopeTipValue" :disabled="scopeTipDisabled" effect="light" content="最大值不能小于最小值" placement="top-start">
                  <input id="numEnd" v-model.number="scopeEnd" @input="handleScopeInput" @blur="onInputBlur('end')" type="number" class="form-control">
                </el-tooltip>
              </div>
            </div>
            <a @click="handleScopeBtnClick" href="javascript:" style="margin-left: 4px" class="btn btn-solid-primary">确定</a>
          </div>
        </div>
        <div class="drop-top">
          <ul class="clearfix" data-action="activeCurrent">
            <li
              @click="handleNANNSearchChange('!null')"
              class="drop-cell">
              <a
                :class="{active: nannSearch === '!null'}"
                href="javascript:;" class="drop-link" data-role="activeTarget">
<!--                <i class="mng icon-solidcircle drop-ico-pre"></i>-->
                <span class="drop-txt">已填写</span>
              </a>
            </li>
            <li
              @click="handleNANNSearchChange('null')"
              class="drop-cell">
              <a
                :class="{active: nannSearch === 'null'}"
                href="javascript:;" class="drop-link" data-role="activeTarget">
<!--                <i class="mng icon-hollowcircle drop-ico-pre"></i>-->
                <span class="drop-txt">未填写</span>
              </a>
            </li>
          </ul>
        </div>
        <div class="drop-mid">
          <div class="clearfix drop-subtitle">
            <span class="pull-left drop-txt">历史搜索</span>
            <a @click="handleClearHistory" href="javascript:" class="btn btn-icon-only pull-right btn-transparent"><i class="mng icon-delete-stroke"></i></a>
          </div>
          <div v-loading="historyIsLoading" class="drop-cell-group">
            <ul class="clearfix">
              <template v-if="searchHistoryData.length > 0">
                <li v-for="item in searchHistoryData" class="drop-cell">
                   <a @click="handleHistoryItemClick(item)" href="javascript:" class="drop-link" style="word-break: break-all;">
                     <div v-html="adjustDataDisplay(item)"></div>
                   </a>
                </li>
              </template>
              <li v-else class="no-history-tip">没有历史搜索记录！</li>
            </ul>
          </div>
        </div>
      </div>
    </whaty-dropdown>
    <!----------- dropdown search:text end ---------->
  </div>
</template>
<script>
  import Clickoutside from 'element-ui/src/utils/clickoutside'
  import util from '../../libs/util'
  import WhatyDropdown from '../whaty-dropdown/whaty-dropdown'

  let _ = require('lodash')

  export default {
    name: 'whaty-search-input-number',
    components: {WhatyDropdown},
    directives: { Clickoutside },
    props: {
      gridConfig: {
        type: Object,
        default() {
          return {}
        }
      },
      gridConfigUrl: {
        type: String,
        default: ''
      },
      value: [String, Number],
      placeholder: String,
      dataIndex: String
    },
    data() {
      return {
        focused: false,
        hovering: false,
        currentValue: '',
        searchHistoryWidth: 300, // 搜索历史面板的宽度
        searchHistoryData: [], // 搜索历史
        searchHistoryDataInitialized: false,
        historyIsLoading: false,
        showSearchHistoryPanel: false, // 是否显示搜索历史面板
        nannSearch: '', // nann: null and not null, !null: 已填写, null: 未填写
        scopeStart: '',
        scopeEnd: '',
        scopeTipDisabled: true,
        scopeTipValue: true,
        numInputShow: 'block',
        numTextShow: 'none'
      }
    },
    computed: {
      queryColumnHotSearchWord: function () {
        return this.gridConfigUrl.replace('abstractGrid', 'queryColumnHotSearchWord')
      },
      clearColumnSearchHistory: function () {
        return this.gridConfigUrl.replace('abstractGrid', 'clearColumnSearchHistory')
      },
      inputStyle() {
        return {
          'padding-right': this.showClear ? '46px' : '26px',
          'display': this.numInputShow
        }
      },
      numTextStyle() {
        return {
          'display': this.numTextShow
        }
      },
      searchHistoryStyle() {
        return {
          width: this.searchHistoryWidth + 'px',
          left: 0
        }
      },
      showClear() {
        return ((this.currentValue && this.currentValue.length > 0) || this.nannSearch) &&
          (this.focused || this.hovering)
      }
    },
    created() {
    },
    mounted() {
      this.popperElm = this.$refs.myPopper.$el
    },
    methods: {
      handleClose() {
        this.showSearchHistoryPanel = false
      },
      loadHotSearchWord(position) {
        this.historyIsLoading = true
        let params = {
          params: {
            actionId: this.gridConfig.gridId,
            gridUrl: this.gridConfigUrl,
            columnDataIndex: this.dataIndex
          }
        }
        util.ajax.post(this.queryColumnHotSearchWord, params).then((res) => {
          this.historyIsLoading = false
          this.searchHistoryDataInitialized = true
          if (res.data.meta.errCode === 0) {
            this.searchHistoryData = res.data.data
            if (position === 'start') {
              document.getElementById('numStart').focus()
            } else if (position === 'end') {
              document.getElementById('numEnd').focus()
            }
          }
        }).catch((err) => {
          this.historyIsLoading = false
          this.searchHistoryDataInitialized = true
          console.warn('获取搜索热词失败！')
          console.error(err)
        })
      },
      getValue() {
        let value = ''
        if (this.nannSearch) {
          value = this.nannSearch
        } else {
          if (((this.scopeStart || this.scopeStart === 0) || (this.scopeEnd || this.scopeEnd === 0))) {
            if (this.scopeStart === this.scopeEnd) {
              value = this.scopeStart + ''
              this.scopeStart = ''
              this.scopeEnd = ''
              this.showInput()
            } else {
              if (this.scopeStart || this.scopeStart === 0) {
                value += ' >= ' + this.scopeStart
              }
              if ((this.scopeStart || this.scopeStart === 0) && (this.scopeEnd || this.scopeEnd === 0)) {
                value += ' and '
              }
              if (this.scopeEnd || this.scopeEnd === 0) {
                value += ' <= ' + this.scopeEnd
              }
              this.showText()
            }
          } else {
            value = this.currentValue
          }
        }
        return value
      },
      emitInput() {
        let value = this.getValue()
        this.$emit('input', value)
      },
      emitChange() {
        let value = this.getValue()
        this.$emit('change', value)
      },
      onInputClick() {
        // 如果已经展示则关闭
        if (this.showSearchHistoryPanel) {
          this.showSearchHistoryPanel = false
          return
        }
        this.loadHotSearchWord()
        this.focused = true
        this.showSearchHistoryPanel = true
      },
      onInputBlur(data) { // input失去焦点时
        if (data === 'input') {
          this.focused = false
          if (!util.checkNum(this.currentValue)) {
            this.currentValue = null
          }
          return
        }
        if (data === 'start') {
          if (!util.checkNum(this.scopeStart)) {
            this.scopeStart = null
          }
          return
        }
        if (data === 'end') {
          if (!util.checkNum(this.scopeEnd)) {
            this.scopeEnd = null
          }
        }
      },
      handleInput(event) { // input输入事件
        this.currentValue = event.target.value
        if (this.focused && this.currentValue) {
          this.showSearchHistoryPanel = false
        }
        this.emitInput()
      },
      handleChange(event) { // input值变化事件
        this.emitChange()
      },
      onCompositionend(e) {
        if (e.target.value === '') {
          e.target.value = 0
          e.target.value = ''
        }
      },
      onClickNumber(position) {
        this.loadHotSearchWord(position)
        this.showSearchHistoryPanel = true
      },
      handleNANNSearchChange(mode) { // 选择NANN搜索事件
        this.currentValue = ''
        this.nannSearch = mode
        this.showSearchHistoryPanel = false
        this.emitInput()
      },
      clear() { // clear btn click event
        this.currentValue = ''
        this.nannSearch = ''
        this.scopeStart = ''
        this.scopeEnd = ''
        this.showInput()
        this.emitInput()
        this.updateScopeTipStatus()
      },
      handleHistoryItemClick(text) {
        if (text.indexOf('and') > -1) {
          this.scopeStart = Number(text.substring(text.indexOf('>=') + 2, text.indexOf('and')))
          this.scopeEnd = Number(text.substring(text.indexOf('<=') + 2, text.length))
          this.showText()
        } else if (text.indexOf('>') > -1) {
          this.scopeStart = Number(text.substring(text.indexOf('>=') + 2, text.length))
          this.scopeEnd = ''
          this.showText()
        } else if (text.indexOf('<') > -1) {
          this.scopeStart = ''
          this.scopeEnd = Number(text.substring(text.indexOf('<=') + 2, text.length))
          this.showText()
        } else {
          this.scopeStart = ''
          this.scopeEnd = ''
          this.showInput()
        }
        this.currentValue = text
        this.nannSearch = ''
        this.showSearchHistoryPanel = false
        this.emitInput()
      },
      handleClearHistory() {
        let params = {
          params: {
            actionId: this.gridConfig.gridId,
            gridUrl: this.gridConfigUrl,
            columnDataIndex: this.dataIndex
          }
        }
        util.ajax.post(this.clearColumnSearchHistory, params).then((res) => {
          if (res.data.meta.errCode === 0) {
            this.searchHistoryData = []
            this.$notify.success({title: '成功', message: '清除成功'})
          }
        }).catch((err) => {
          this.$notify.success({title: '成功', message: '清除成功'})
          console.warn('清除列搜索记录失败！')
          console.error(err)
        })
      },
      handleScopeInput: _.debounce(
        function () {
          this.updateScopeTipStatus()
        },
        500 // 用户输入结束判定延迟时间
      ),
      updateScopeTipStatus() {
        this.scopeTipDisabled = !(this.showSearchHistoryPanel && (this.scopeStart && this.scopeEnd && this.scopeStart > this.scopeEnd))
        this.$refs.scopeTip.updatePopper()
      },
      handleScopeBtnClick() {
        if (this.scopeTipDisabled) {
          this.handleClose()
          if (!((this.scopeStart || this.scopeStart === 0) || (this.scopeEnd || this.scopeEnd === 0))) {
            this.currentValue = ''
            this.nannSearch = ''
            this.showInput()
            this.updateScopeTipStatus()
          }
          this.emitInput()
        }
      },
      adjustDataDisplay(item) { // 处理历史查询的数据展示
        let spanContext = ``
        let scopeStart = ''
        let scopeEnd = ''
        if (item.indexOf('and') > -1) {
          scopeStart = Number(item.substring(item.indexOf('>=') + 2, item.indexOf('and')))
          scopeEnd = Number(item.substring(item.indexOf('<=') + 2, item.length))
          spanContext = `<span class="drop-txt">${scopeStart}至${scopeEnd}</span>`
        } else if (item.indexOf('>') > -1) {
          scopeStart = Number(item.substring(item.indexOf('>=') + 2, item.length))
          spanContext = `<span class="drop-txt">${scopeStart}至—</span>`
        } else if (item.indexOf('<') > -1) {
          scopeEnd = Number(item.substring(item.indexOf('<=') + 2, item.length))
          spanContext = `<span class="drop-txt" v-else>—至${scopeEnd}</span>`
        } else {
          spanContext = `<span class="drop-txt" v-else>${item}</span>`
        }
        return spanContext
      },
      showText() {
        this.numTextShow = 'block'
        this.numInputShow = 'none'
      },
      showInput() {
        this.numTextShow = 'none'
        this.numInputShow = 'block'
      }
    },
    watch: {
      value: function value(val) {
        if (val === undefined) {
          this.clear()
        } else if (val === 'null' || val === '!null') { // if val equal nannSearch
          this.nannSearch = val
        } else {
          if (val.indexOf('and') > -1) {
            this.scopeStart = Number(val.substring(val.indexOf('>=') + 2, val.indexOf('and')))
            this.scopeEnd = Number(val.substring(val.indexOf('<=') + 2, val.length))
            this.showText()
          } else if (val.indexOf('>') > -1) {
            this.scopeStart = Number(val.substring(val.indexOf('>=') + 2, val.length))
            this.scopeEnd = ''
            this.showText()
          } else if (val.indexOf('<') > -1) {
            this.scopeStart = ''
            this.scopeEnd = Number(val.substring(val.indexOf('<=') + 2, val.length))
            this.showText()
          } else {
            this.scopeStart = ''
            this.scopeEnd = ''
            this.showInput()
          }
          this.nannSearch = ''
          this.currentValue = val
        }
      },
      showSearchHistoryPanel() {
        this.updateScopeTipStatus()
      }
    }
  }
</script>
<style src="./index.scss" lang="scss"></style>



// WEBPACK FOOTER //
// src/components/whaty-search-input-number/index.vue